export const logger = (...args: unknown[]): void => {
  if (
    process.env.REACT_APP_ENVIRONMENT !== 'production' &&
    process.env.REACT_APP_ENVIRONMENT !== 'staging'
  ) {
    console.log(...args);
  }
};
